import { fireApiErrorSentry } from '@porterin/component-library/src/ts-utils/analytics/sentry/SentryHelpers';
import axios from 'axios';

export function handleApiError(error: unknown, source: string): void {
  if (
    axios.isAxiosError(error) &&
    error.response &&
    error.response.status < 500
  ) {
    return;
  }
  fireApiErrorSentry(error, source);
}
